import { IUserPermission, IUserPermissions, IUserToken, PermissionConstants } from '@module/shared';

class PermissionsServiceClass {
  private basePath: string;

  constructor() {
    this.basePath = `${environmentSettings.webapiUrl}/v1/Permissions`;
  } 

  async getUserPermissions(user: IUserToken): Promise<IUserPermissions> {
    const response = await this.sendRequest(user, 'GET');
    if (response.ok) {
      const json = await response.json();
      return json;
    } else {
      return Promise.reject(`System error: ${response.status} ${response.statusText}`);
    }
  }
  
  IsAdministrator(permissions: IUserPermission[]) {
    return permissions.some(p => p.code === PermissionConstants.AdministerPartInventory);
  }

  IsSpecialist(permissions: IUserPermission[]) {
    return permissions.some(p => p.code === PermissionConstants.ManagePartInventory);
  }

  private sendRequest(user: IUserToken, httpMethod: string) {
    const headers = new Headers();
    headers.append('Authorization', 'Bearer ' + user.access_token);
    headers.append('pragma', 'no-cache');
    headers.append('cache-control', 'no-cache');
    headers.append('access-control-allow-methods', 'GET, HEAD, POST, PUT, PATCH, DELETE, OPTIONS');
    return fetch(`${this.basePath}`, { headers, method: httpMethod, cache: 'no-store' });
  }

}

export const PermissionsService = new PermissionsServiceClass();  
export default PermissionsService;
